<script>
import transportTypes from '../../../variables/transportTypes';
import ItineraryPricesTransportSearchFeed from './ItineraryPricesTransportSearchFeed';

export default {
  name: 'ItineraryPricesTransportSearchBar',
  components: {
    ItineraryPricesTransportSearchFeed,
  },
  props: {
    selectedPriceInterval: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    transits: {
      type: Array,
      required: true,
    },
    carriers: {
      type: Array,
      required: true,
    },
    itineraryLength: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      searchBody: {
        type: null,
        fromDate: this.selectedPriceInterval.arrivalFrom,
        toDate: this.selectedPriceInterval.arrivalTo,
        departureDate: null,
        departureTransitId: null,
        arrivalTransitId: null,
        carrierId: null,
        tripReference: null,
        pnrNumber: null,
        outBoundDays: [],
        duration: this.itineraryLength,
      },
      transportTypes: [
        transportTypes.FLIGHT,
        transportTypes.CRUISE,
        transportTypes.TRAIN,
      ],
      searchFeedDialog: false,
      selectedAllotments: [],
      included: false,
    };
  },
  watch: {
    selectedPriceInterval: {
      immediate: true,
      handler(value) {
        this.searchBody.fromDate = value.arrivalFrom;
        this.searchBody.toDate = value.arrivalTo;
        this.searchBody.outBoundDays = value.intervalDays.map(e => e.day);
      },
    },
  },
  methods: {
    filterTransits(item, queryText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
        item.iataCode.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    setTransportType(value) {
      this.searchBody.type = value;
    },
    setDepartureTransit(value) {
      this.searchBody.departureTransitId = typeof value !== 'undefined' ? value.id : null;
    },
    setArrivalTransit(value) {
      this.searchBody.arrivalTransitId = typeof value !== 'undefined' ? value.id : null;
    },
    setCarrier(value) {
      this.searchBody.carrierId = typeof value !== 'undefined' ? value.id : null;
    },
    setPNR(value) {
      this.searchBody.pnrNumber = value !== '' ? value : null;
    },
    search() {
      const searchBody = {
        ...this.searchBody,
        duration: this.itineraryLength,
      };
      this.$emit('search', searchBody);
    },
  },
};
</script>

<template>
    <div>
      <h3 v-if="!expanded">Search and add transport</h3>
      <v-layout class="mt-4">
        <v-flex v-if="expanded" class="mr-2">
          <v-checkbox
            v-model="included"
            label="Included"
            class="mt-3"
            @change="$emit('included', included)"
          />
        </v-flex>
        <v-flex class="mr-2" xs1>
          <v-select
            :items="transportTypes"
            label="Type"
            clearable
            solo
            @change="setTransportType"
          />
        </v-flex>
        <v-flex class="mr-2" xs4>
          <v-autocomplete
            :items="transits"
            :value="searchBody.departureTransitId"
            :filter="filterTransits"
            :label="$t('nonDynamicTransport.labels.departureAirport')"
            class="mr-2"
            item-text="name"
            item-value="id"
            solo
            return-object
            clearable
            @change="setDepartureTransit"
          >
            <template v-slot:selection='data'>
              {{ data.item.name }} - ({{ data.item.iataCode }})
            </template>
            <template v-slot:item='data'>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ data.item.name }} - ({{ data.item.iataCode }})
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex class="mr-2" xs4>
          <v-autocomplete
            :items="transits"
            :value="searchBody.arrivalTransitId"
            :filter="filterTransits"
            :label="$t('nonDynamicTransport.labels.arrivalAirport')"
            class="mr-2"
            item-text="name"
            item-value="id"
            solo
            return-object
            clearable
            @change="setArrivalTransit"
          >
            <template v-slot:selection='data'>
              {{ data.item.name }} - ({{ data.item.iataCode }})
            </template>
            <template v-slot:item='data'>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ data.item.name }} - ({{ data.item.iataCode }})
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex class="mr-2" xs2>
          <v-select
            :items="carriers"
            :label="$t('nonDynamicTransport.labels.carrier')"
            class="mr-2"
            item-text="name"
            item-value="id"
            solo
            small-chips
            clearable
            return-object
            @change="setCarrier"
          />
        </v-flex>
        <v-flex class="mr-2" xs1>
          <v-text-field
            solo
            label="PNR"
            @input="setPNR"
          />
        </v-flex>
        <v-flex class="mr-2">
          <v-btn
            color="primary"
            label="Button"
            @click="search"
          >
            Search
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesTransportSearchBar.vue